 <template lang="pug">
  section#files
    v-container.px-10(fluid)
      v-row(justify-center, style="overflow: hidden")
        v-col
          h2.primary--text Summary
      v-row
        v-col
          h3.primary--text.pb-5 Shipment ID {{parentInstance.externalId}}
      v-row.summary-row
        v-col(cols="2")
          h3.primaryHover--text General Information
        v-col.summary-col(cols="10")
          v-row()
            v-col.justify-center(cols="3")
              span(class="summary-header") Shipper Reference:
              span(class="summary-text") {{ summaryInstance.shipmentReference }}
            v-col.justify-center(cols="3")
              span(class="summary-header") Receiver Reference:
              span(class="summary-text") {{ summaryInstance.receiverReference }}
            v-col.justify-center(cols="3")
              span(class="summary-header") Created By:
              span(class="summary-text") {{ summaryInstance.createdBy }}
            v-col.justify-center(cols="3")
              span(class="summary-header") Business Scope:
              span(class="summary-text") {{ summaryInstance.businessScope }}
      v-row.summary-row
        v-col(cols="2")
          h3.primaryHover--text Pick & Delivery
        v-col.summary-col.justify-center.pt-3(cols="5")
          span(class="summary-header") Requested Pickup Date:
          br
          span(v-if="summaryInstance.requestedPickUpFromDate != null" class="summary-text") {{ $formattedDate(summaryInstance.requestedPickUpFromDate, true) }}
          span(v-if="summaryInstance.requestedPickUpToDate != null" class="summary-text")   -- {{ $formattedDate(summaryInstance.requestedPickUpToDate, true) }}
          br
          span(class="summary-header") Ship From:
          span(class="summary-text") {{ summaryInstance.partyFromName }}
          br
          span(class="summary-text") {{ summaryInstance.partyFromStreetName }}
          br
          span(class="summary-text") {{ summaryInstance.partyFromInteriorNumber }}
          br
          span(class="summary-text") {{ summaryInstance.partyFromCityName }}
          br
          span(class="summary-text") {{ summaryInstance.partyFromPostalCode }}
          br
          span(class="summary-text") {{ summaryInstance.partyFromRemarks }}
          br
          v-row(v-for="extData in summaryInstance.partyFromExtraData")
            span.pl-3(class="summary-text") {{ `${extData.extraField.label}: ${extData.value}` }}
            br
          span(class="summary-header") Contacts:
          br
          v-row(v-for="c in summaryInstance.partyFromContacts")
            span.pl-3(class="summary-text") {{ c.contact }}
            br
        v-col.summary-col.justify-center.pt-3(cols="5")
          span(class="summary-header") Requested Delivery Date:
          br
          span(v-if="summaryInstance.requestedDeliveryFromDate != null" class="summary-text") {{ $formattedDate(summaryInstance.requestedDeliveryFromDate, true) }}
          span(v-if="summaryInstance.requestedDeliveryToDate != null" class="summary-text")   -- {{ $formattedDate(summaryInstance.requestedDeliveryToDate, true) }}
          br
          span(class="summary-header") Ship To:
          span(class="summary-text") {{ summaryInstance.partyToName }}
          br
          span(class="summary-text") {{ summaryInstance.partyToStreetName }}
          br
          span(class="summary-text") {{ summaryInstance.partyToInteriorNumber }}
          br
          span(class="summary-text") {{ summaryInstance.partyToCityName }}
          br
          span(class="summary-text") {{ summaryInstance.partyToPostalCode }}
          br
          span(class="summary-text") {{ summaryInstance.partyToRemarks }}
          br
          v-row(v-for="extData in summaryInstance.partyToExtraData")
            span.pl-3(class="summary-text") {{ `${extData.extraField.label}: ${extData.value}` }}
            br
          span(class="summary-header") Contacts:
          br
          v-row(v-for="c in summaryInstance.partyToContacts")
            span.pl-3(class="summary-text") {{ c.contact }}
            br
      v-row.summary-row
        v-col(cols="2")
          h3.primaryHover--text Packages
        v-col.summary-col(cols="10")
          v-row
            v-col.justify-center(cols="3")
              span(class="summary-header") Handling Units:
              span(class="summary-text")  {{ parentInstance.packages != null ? parentInstance.packages.length : 0 }}
            v-col.justify-center(cols="3")
              span(class="summary-header") Total Weight:
              span(class="summary-text")  {{ summaryInstance.packagesTotalWeightKg | fixed }} kg. / {{ summaryInstance.packagesTotalWeightLb | fixed }} lb.
            v-col.justify-center(cols="3")
              span(class="summary-header") Total Volume:
              span(class="summary-text")  {{  summaryInstance.packagesTotalVolume | fixed }} cm³
          v-row(v-for="p in summaryInstance.packages")
            v-col.summary-col.justify-center(cols="3")
              span(class="summary-header") {{ p.packagePackaging }}
              span(class="summary-text") {{ p.packageDimensions }}
            v-col.summary-col(cols="9")
              v-row
                v-col.summary-col(v-for="ped in p.packageExtraFields", cols="4")
                  span(class="summary-header") {{ ped.labelName }}:
                  span(class="summary-text")  {{ ped.value }}
      v-row.summary-row
        v-col(cols="2")
          h3.primaryHover--text Package Contents
        v-col.summary-col(cols="10")
          v-row(v-for="pc in summaryInstance.packageContents")
            v-col.justify-center(cols="3")
              span(class="summary-header") {{ pc.shippingQuantity }}
              span(class="summary-text")   {{ pc.productName }}
              span(class="summary-text")   {{ pc.relatedExternalId }}
            v-col.summary-col.pt-3.pb-1(cols="9")
              v-row(v-if="pc.packageContentExtraFields")
                v-col.summary-col(v-for="pced in pc.packageContentExtraFields.extraData", cols="4")
                  span(class="summary-header") {{ pced.labelName }}:
                  span(class="summary-text")  {{ pced.value }}
      v-row.summary-row(v-for="sed in summaryInstance.shipmentExtraData")
        v-col(cols="2")
          h3.primaryHover--text {{ sed[0].groupName != null ? sed[0].groupName : sed[0].key != null ? sed[0].key.split('.')[0] : "" }}
        v-col(cols="10")
          v-row
            v-col.summary-col(v-for="ef in sed", cols="3")
              span(class="summary-header") {{ ef.extraField != null ? ef.extraField.label : ef.labelName }}:
              span(class="summary-text")    {{ ef.type == "Datetime" ? $formattedDate(ef.value, true) : ef.value }}
      v-row.summary-row
        v-col(cols="2")
          h3.primaryHover--text Files
        v-col(cols="10")
          v-row(v-for="f in summaryInstance.files")
            v-col.summary-col.justify-center
              span(class="summary-header") {{ f.label }} :
              span(class="summary-text")  {{ f.fileName }}
              span(class="summary-text")  ({{ f.fileFormat }})
</template>

<style lang="scss" scoped>
  .summary-header{
    font-family: "Avenir LT", "Roboto", sans-serif;
    font-size: 14px;
    font-weight: bold;
    line-height: 17px;
  }
  .summary-text{
    font-family: "Avenir LT", "Roboto", sans-serif;
    font-size: 14px;
    line-height: 17px;
  }
  .summary-row{
    border-bottom: 1px solid #cccccc
  }
  .summary-col{
    padding: 2px 2px 2px 12px;
  }
</style>

<script>
import axios from 'axios';
import moment from 'moment-timezone';
import EntityMixin from '@/mixins'

export default {
  name: 'SummaryShipment',
  props: {
    parentInstance: {
      type: Object,
      default: () => { return {} }
    },
    entity: {
      type: Object
    },
    path: {
      type: String
    },
    parentPath: {
      type: String
    },
  },
  filters: {
    fixed(val) {
      return Number.parseFloat(val).toFixed(2);
    },
  },
  data: function () {
    return {
      instance: {},
      summaryInstance : {}
    }
  },
  watch: {
    parentInstance: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val != null) {
          this.updateSummaryInstance(val)
        }
      },
    },
  },
  computed: {
    errors() {
        return this.$store.state.errors;
    },
    totalWeightConverted() {
      return _.reduce(this.parentInstance.packages, (res, { packagingWeight, weightUnit }) => {
        if (!packagingWeight || !weightUnit) return res;
        const floatWeight = parseFloat(packagingWeight);
        const totalWeight = weightUnit === 'kg' ? floatWeight : this.libraToKilograms(floatWeight);
        return res + totalWeight;
      }, 0.0);
    },
    totalVolumeConverted() {
      return _.reduce(this.parentInstance.packages, (res, { packagingWidth, packagingHeight, packagingLength, dimensionUnit }) => {
        if (!packagingWidth || !packagingHeight || !packagingLength || !dimensionUnit) return res;
        const floatWidth = parseFloat(packagingWidth);
        const floatHeight = parseFloat(packagingHeight);
        const floatLength = parseFloat(packagingLength);
        const floatVolume = floatWidth * floatHeight * floatLength;
        const totalVolume = dimensionUnit === 'cm' ? floatVolume : this.inchesToCentimeters(floatVolume);
        return res + totalVolume;
      }, 0.0);
    },
  },
  methods: {
    libraToKilograms(v) {
      try{ return v/2.2046 } catch { return 0 };
    },
    kilogramsToLibra(v) {
      try{ return v*2.2046; } catch { return 0 };
    },
    centimetersToInches(v) {
      try{ return v*0.39370; } catch { return 0 };
    },
    inchesToCentimeters(v) {
      try{ return v/0.39370 } catch { return 0 };
    },
    updateSummaryInstance(parentInstance, firstTimeInstance = null, firstTime = false){
      /// parentInstance - Model instance listening all changes by the user when edit
      /// firstTimeInstance - Instance when load the first time from Summary Controller
      /// firstTime - Flag to know if its the first time load summary
      if(parentInstance.shipperReference != null ) this.summaryInstance.shipmentReference = parentInstance.shipperReference
      if(parentInstance.receiverReference != null ) this.summaryInstance.receiverReference = parentInstance.receiverReference
      if(this.summaryInstance.createdBy == null) this.summaryInstance.createdBy = parentInstance.user ? parentInstance.user.fullName : ''
      if(this.summaryInstance.businessScope == null) this.summaryInstance.businessScope = parentInstance.businessScope.path

      // Party From
      if(parentInstance.datePickupFrom != null) this.summaryInstance.requestedPickUpFromDate = this.$cleanNulls(parentInstance.datePickupFrom)
      if(parentInstance.datePickupTo != null ) this.summaryInstance.requestedPickUpToDate = this.$cleanNulls(parentInstance.datePickupTo)
      if(parentInstance.partyFrom != null ){
        this.summaryInstance.partyFromName = this.$cleanNulls(parentInstance.partyFrom.name) + " (" + this.$cleanNulls(parentInstance.partyFrom.externalId) + ")"
        this.summaryInstance.partyFromStreetName = this.$cleanNulls(parentInstance.partyFrom.streetName) + " " + this.$cleanNulls(parentInstance.partyFrom.exteriorNumber)
        this.summaryInstance.partyFromInteriorNumber = this.$cleanNulls(parentInstance.partyFrom.interiorNumber)
        this.summaryInstance.partyFromCityName = this.$cleanNulls(parentInstance.partyFrom.cityName) + ", " + this.$cleanNulls(parentInstance.partyFrom.stateName) + ", "  + this.$cleanNulls(parentInstance.partyFrom.countryCode)
        this.summaryInstance.partyFromPostalCode = this.$cleanNulls(parentInstance.partyFrom.postalCode)
        this.summaryInstance.partyFromRemarks = this.$cleanNulls(parentInstance.partyFrom.remarks1)
        this.summaryInstance.partyFromContacts = parentInstance.shipmentContacts.filter(c => c.contactType == 0 && c.entityState != 2).map(c => ({
          contact: c.contact != null ? (this.$cleanNulls(c.contact.name) + " - " + this.$cleanNulls(c.contact.eMail) + " - " + this.$cleanNulls(c.contact.phoneNumber)) : null
        }));
        if(parentInstance.partyFrom.extraData != null) this.summaryInstance.partyFromExtraData = this.$cleanNulls(parentInstance.partyFrom.extraData)
      }

      //Party To
      if(parentInstance.dateDeliveryFrom != null) this.summaryInstance.requestedDeliveryFromDate = this.$cleanNulls(parentInstance.dateDeliveryFrom)
      if(parentInstance.dateDeliveryTo != null ) this.summaryInstance.requestedDeliveryToDate = this.$cleanNulls(parentInstance.dateDeliveryTo)
      if(parentInstance.partyTo != null ){
        this.summaryInstance.partyToName = this.$cleanNulls(parentInstance.partyTo.name) + " (" + this.$cleanNulls(parentInstance.partyTo.externalId) + ")"
        this.summaryInstance.partyToStreetName = this.$cleanNulls(parentInstance.partyTo.streetName) + " " + this.$cleanNulls(parentInstance.partyTo.exteriorNumber)
        this.summaryInstance.partyToInteriorNumber = this.$cleanNulls(parentInstance.partyTo.interiorNumber)
        this.summaryInstance.partyToCityName = this.$cleanNulls(parentInstance.partyTo.cityName) + ", " + this.$cleanNulls(parentInstance.partyTo.stateName) + ", "  + this.$cleanNulls(parentInstance.partyTo.countryCode)
        this.summaryInstance.partyToPostalCode = this.$cleanNulls(parentInstance.partyTo.postalCode)
        this.summaryInstance.partyToRemarks = this.$cleanNulls(parentInstance.partyTo.remarks1)
        this.summaryInstance.partyToContacts = parentInstance.shipmentContacts.filter(c => c.contactType == 1 && c.entityState != 2).map(c => ({
          contact: c.contact != null ? (this.$cleanNulls(c.contact.name) + " - " + this.$cleanNulls(c.contact.eMail) + " - " + this.$cleanNulls(c.contact.phoneNumber)) : null
        }));
        if(parentInstance.partyTo.extraData != null) this.summaryInstance.partyToExtraData = this.$cleanNulls(parentInstance.partyTo.extraData)
      }

      //Packages
      if(parentInstance.packages != null) {
        this.summaryInstance.packages = parentInstance.packages.filter(p => p.entityState != 2).map(p => ({
          packagePackaging: p.packaging != null ? this.$cleanNulls(p.packaging) + " (" + this.$cleanNulls(p.caseIdentifier) + ") " : "",
          packageDimensions: (p.packagingLength != null && p.packagingWidth != null && p.packagingHeight != null) ? this.$cleanNulls(p.packagingLength) + " x " + this.$cleanNulls(p.packagingWidth) + " x " + this.$cleanNulls(p.packagingHeight) + " " + this.$cleanNulls(p.dimensionUnit) + " - " + this.$cleanNulls(p.packagingWeight) + " " + this.$cleanNulls(p.weightUnit) : "",
          packageExtraFields: p.extraData != null ? p.extraData.map(ed => ({
            groupName: ed.key != null ? ed.key.split('.')[0] : '',
            labelName: ed.extraField != null ? ed.extraField.label : ed.labelName,
            value: ed.value
          })) : null
        }));
        this.summaryInstance.packagesTotalWeightKg = this.$cleanNulls(this.totalWeightConverted)
        this.summaryInstance.packagesTotalWeightLb = this.$cleanNulls(this.kilogramsToLibra(this.totalWeightConverted));
        this.summaryInstance.packagesTotalVolume = this.$cleanNulls(this.totalVolumeConverted)
      }

      //Package Contents
      if(parentInstance.packageContents != null) {
        this.summaryInstance.packageContents = parentInstance.packageContents.filter(pc => pc.entityState != 2).map(pc => ({
            shippingQuantity: pc.quantity,
            productName: pc.product != null ? pc.product.name : null,
            shipmentItemNo: pc.itemNo,
            relatedExternalId: pc.orderLine != null ? '(OrderLine ' + pc.orderLine.externalId + ')' : pc.product != null ? '(' + pc.product.externalId + ')' : null,
            packageContentExtraFields: parentInstance.shipmentItems.filter(si => si.itemNo == pc.itemNo).map(si => ({
              extraData: si.extraData != null ? si.extraData.map(ed => ({
                  groupName: ed.key != null ? ed.key.split('.')[0] : '',
                  labelName: ed.extraField != null ? ed.extraField.label : ed.labelName,
                  value: ed.value
                })) : null
            }))[0]
        }));
        //Group packageContents according to its shipmentItemNo
        this.summaryInstance.packageContents = Object.values(this.summaryInstance.packageContents.reduce((prev, next) => (prev[next.shipmentItemNo]
          ? (prev[next.shipmentItemNo].shippingQuantity += next.shippingQuantity)
          : (prev[next.shipmentItemNo] = {...next}), prev), {}));
      }

      //ExtraData
      if(firstTime) this.summaryInstance.shipmentExtraData = firstTimeInstance.shipmentExtraData
      else if(parentInstance.extraData != null){
        this.summaryInstance.shipmentExtraData = _.groupBy(parentInstance.extraData, function (ed) {
          return ed.key != null ? ed.key.split('.')[0] : ed.groupName;
        });
      }

      //Files already saved
      var currentFiles = []
      if(this.summaryInstance.files != null){
        parentInstance.files.forEach(
          element => currentFiles.push(this.summaryInstance.files.filter(f => f.id == element.id)[0])
        );
      }

      //Files to upload
      if(parentInstance.documentsRequestsToUpload != null){
        parentInstance.documentsRequestsToUpload.forEach(
          element => {
            let splitedFileName = element.FileName.split('.');
            const [ fileFormat ] = splitedFileName.slice(-1);
            splitedFileName.pop();
            currentFiles.push({
                label: element.DocumentRequestLabel,
                fileName: splitedFileName.join('.'),
                fileFormat
            })
          }
        );
      }
      this.summaryInstance.files = currentFiles
    },
    async load () {
      if (this.parentInstance.uid) {
        try {
          this.summaryInstance = (await axios.get(`summary/shipment/${this.parentInstance.uid}`)).data;
          this.updateSummaryInstance(this.parentInstance, this.summaryInstance, true)
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      }
    },
  },
  async created() {
    await this.load();
  },
}
</script>

